import axios from '@axios'

export function ServiceLogsError() {
  this.getErros = filters => new Promise((resolve, reject) => {
    axios.get('errors', { params: filters })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject({
          message: err.response.data.message,
          status: err.response.status,
        })
      })
  })
}
